export default {
  title: {
    id: 'bo_sellers-orders-drawers-request_pickup_drawer-title',
    defaultMessage: 'Cancel pickup',
  },
  prompt: {
    id: 'bo_sellers-orders-drawers-request_pickup_drawer-choose_a_pickup_date',
    defaultMessage: 'Choose a pickup date for order {orderId}',
  },
  confirm: {
    id: 'bo_sellers-orders-drawers-request_pickup_drawer-request_pickup',
    defaultMessage: 'Request pickup',
  },
  cancel: {
    id: 'bo_sellers-orders-drawers-request_pickup_drawer-cancel',
    defaultMessage: 'Cancel',
  },
  pickupDate: {
    id: 'bo_sellers-orders-drawers-request_pickup_drawer-pickup_date',
    defaultMessage: 'Select a pickup date',
  },
  required: {
    id: 'bo_sellers-orders-drawers-request_pickup_drawer-required',
    defaultMessage: 'This field is required',
  },
  success: {
    id: 'bo_sellers-orders-drawers-request_pickup_drawer-pickup_confirmation',
    defaultMessage: 'You pickup date is confirmed',
  },
} as const
